export const S3_IMAGE_BUCKET = 'https://david-sperling-web-frontend-img.s3.amazonaws.com/'
